import React, { useState, useEffect, useRef } from 'react';
import Numeral from "numeral";
import "numeral/locales/pt-br";

function AnimatedMonetaryConverter(props) {
    Numeral.locale('pt-br');

    const [displayValue, setDisplayValue] = useState(0);
    const animationRef = useRef(null);
    const previousValue = useRef(0);

    const targetValue = Number(props.quantity) || 0;
    const duration = props.duration || 1500; // Duracao em ms

    useEffect(() => {
        const startValue = previousValue.current;
        const startTime = performance.now();

        // Cancela animacao anterior se existir
        if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
        }

        // Funcao de easing para suavizar a animacao
        const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Aplica easing
            const easedProgress = easeOutQuart(progress);

            // Calcula valor atual
            const currentValue = startValue + (targetValue - startValue) * easedProgress;
            setDisplayValue(currentValue);

            if (progress < 1) {
                animationRef.current = requestAnimationFrame(animate);
            } else {
                previousValue.current = targetValue;
            }
        };

        animationRef.current = requestAnimationFrame(animate);

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [targetValue, duration]);

    const converted = Numeral(displayValue).format('$0,0.00');

    return (
        <span className={props.class}>{converted}</span>
    );
}

export default AnimatedMonetaryConverter;
